module.exports = __webpack_public_path__ + "img/notificationIcon.d8a515a0.svg";